import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const [sidebarSize, setSidebarSize] = useState("lg");

  // Function to toggle sidebar
  const toggleSidebar = () => {
    setSidebarSize(sidebarSize === "lg" ? "sm" : "lg");
  };

  // Update body attributes on sidebar size change
  useEffect(() => {
    document.body.setAttribute("data-sidebar-size", sidebarSize);

    if (sidebarSize === "sm") {
      document.body.classList.add("sidebar-enable");
    } else {
      document.body.classList.remove("sidebar-enable");
    }
  }, [sidebarSize]);

    return (
        <div>
            <div id="layout-wrapper">
                <Header toggleSidebar={toggleSidebar} />
                <Sidebar />
                {/* <!-- ============================================================== -->
        <!-- Start right Content here -->
        <!-- ============================================================== --> */}
                <div className="main-content">
                    <div className="page-content">{children}</div>
                </div>
            </div>
            <div className="rightbar-overlay"></div>
            <Footer />
        </div>
    );
};

export default Layout;
